import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import { IMGAMatchupsGameLayout } from './imga-matchups-game-layout';
import { isMobile } from '../../../general/js/utils/screen-size-utils';

class IMGAMatchupsGameComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.updatePaddingTop();
        this.render();
    }

    updatePaddingTop() {
        const {
            iFrameAspectRatioWidth,
            iFrameAspectRatioHeight,
            mobileIFrameAspectRatioHeight,
            mobileIFrameAspectRatioWidth
        } = this.options;

        const desktopPaddingTopPercent = `${(iFrameAspectRatioHeight / iFrameAspectRatioWidth) * 100}%`;
        const mobilePaddingTopPercent = `${(mobileIFrameAspectRatioHeight / mobileIFrameAspectRatioWidth) * 100}%`;

        this.element.style.paddingTop = isMobile() ? mobilePaddingTopPercent : desktopPaddingTopPercent;
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Fragment>
                <IMGAMatchupsGameLayout {...this.options} />
            </Fragment>,
            this.element
        );
    }
}

export default IMGAMatchupsGameComponent;
